const API_URI = process.env.REACT_APP_URL || 'https://seminar-api.expertus.com.ua';
const URL_ID3 = process.env.REACT_APP_URL_ID3 || 'https://id3.expertus.com.ua';
const URL_ID3_CABINET = process.env.REACT_APP_URL_ID3_CABINET || 'https://id.expertus.com.ua';
const APP_ID = process.env.REACT_APP_APP_ID || 2562;

const config = {
  API_URI,
  URL_ID3,
  APP_ID,
  URL_ID3_CABINET,
};

export default config;
